import { EventDispatcher } from '@sg-core/resources/assets/js/libs/event-dispatcher';

export const CLASS_INSTANCES_EVENTS = {
  CREATED: 'class-instance:created',
  DELETED: 'class-instance:deleted',
};

/**
 * A weak map to track class instances associated with their DOM element.
 * It's safer to do so instead of adding them as a DOM property so they
 * can be garbage collected even if referenced in the map.
 *
 * see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/WeakMap
 *
 * This is useful when we need to listen for custom event triggered by
 * the instance in other unrelated classes (see PIA SearchPanel as an
 * example) or access instance methods and properties from outside the
 * class.
 */
class ClassInstances extends EventDispatcher {
  #instances = new WeakMap();

  get(element: HTMLElement) {
    return this.#instances.get(element);
  }

  set(element: HTMLElement, instance: unknown) {
    this.#instances.set(element, instance);

    this.dispatchEvent(CLASS_INSTANCES_EVENTS.CREATED, { element, instance });
  }

  has(element: HTMLElement) {
    return this.#instances.has(element);
  }

  delete(element: HTMLElement) {
    this.#instances.delete(element);

    this.dispatchEvent(CLASS_INSTANCES_EVENTS.DELETED, { element });
  }
}

export const classInstances = new ClassInstances();
